import clsx from 'clsx'
import { TextareaHTMLAttributes } from 'react'
import {
  FieldNamesMarkedBoolean,
  FieldValues,
  Path,
  UseFormRegister,
} from 'react-hook-form'
import { EditedBadge } from '../EditedBadge'

interface TextAreaFieldProps<T extends FieldValues>
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'name'> {
  name: Path<T>
  label: string
  register: UseFormRegister<T>
  dirtyFields?: Partial<Readonly<FieldNamesMarkedBoolean<T>>>
  rows?: number
  placeholder?: string
  validation?: object
  error?: string
}

export const TextAreaField = <T extends FieldValues>({
  name,
  label,
  register,
  dirtyFields,
  rows = 5,
  validation,
  placeholder,
  error,
  className,
  ...props
}: TextAreaFieldProps<T>) => {
  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <label
        htmlFor={name}
        className="flex items-center text-md font-medium text-white"
      >
        <strong>{label}</strong>
        {dirtyFields && (
          <EditedBadge
            isEdited={dirtyFields?.[name as keyof typeof dirtyFields] === true}
          />
        )}
      </label>
      <textarea
        {...register(name, validation)}
        id={name}
        className={clsx(
          '!w-full px-4 py-2 tc-mv-question-field text-white rounded-2xl outline-none !resize-y no-scrollbar',
          {
            'border-red-500': error,
          },
        )}
        rows={rows}
        placeholder={placeholder}
        {...props}
      />
      {error && <span className="text-red-500 text-sm pl-2">{error}</span>}
    </div>
  )
}
